// ** Custom Components
import Link from "components/layout/Link";

// #####################################################

export const StyledLink = (props) => (
	<Link {...props} color="primary" size="0.8rem" underline />
);

// #####################################################
